<template>
  <div v-if="cart.microsoft365.length">
    <StoreInit store="microsoft-365-catalog">
      <template #fallback>
        <ShoppingCartSectionSkeleton title="Servere" />
      </template>

      <UDashboardCard
        :title="`Microsoft 365`"
        :description="`${cart.microsoft365.length} abonnementer i handlekurven`"
        :links="[
          {
            label: 'Endre / Legg til flere',
            color: 'gray',
            to: '/microsoft-365',
          },
        ]"
      >
        <ShoppingCartItem v-for="item in cart.microsoft365" :item-id="item.id!">
          <template #description>
            {{ item.microsoft365?.firstName }} {{ item.microsoft365?.lastName }}

            <div class="text-xs font-normal">
              {{
                microsoft365Catalog.getPackageBySubscriptionId(
                  item.microsoft365!.subscriptionId!
                )!.name
              }}
              ({{
                getAgreementPeriodHumanText(
                  microsoft365Catalog.getSubscriptionById(
                    item.microsoft365!.subscriptionId!
                  )?.agreementPeriodType!,
                  false
                )
              }})
            </div>
          </template>

          <template #price>
            <div :class="['flex items-center flex-row space-x-2']">
              <Microsoft365PriceDisplay
                :subscription-id="item.microsoft365?.subscriptionId!"
              />
            </div>
          </template>

          <template #addons v-if="item.microsoft365?.hasCoPilot">
            <div
              class="text-xs flex flex-row w-full justify-between items-center"
            >
              <div>+ Copilot for Microsoft 365</div>
              <div class="mr-16 text-gray-500 text-xs whitespace-nowrap">
                <div :class="['flex-row items-center space-x-2', 'flex']">
                  kr. {{ formatPrice(copilotPrice) }} per år
                </div>
              </div>
            </div>
          </template>
        </ShoppingCartItem>
      </UDashboardCard>
    </StoreInit>
  </div>
</template>

<script lang="ts" setup>
import { getAgreementPeriodHumanText } from "~/helpers/agreementPeriodHelper";
import { useMicrosoft365CatalogStore } from "~/stores/catalog/microsoft-365-catalog";
import Microsoft365PriceDisplay from "../microsoft-365/Microsoft365PriceDisplay.vue";
import { formatPrice } from "~/helpers/priceHelpers";

const microsoft365Catalog = useMicrosoft365CatalogStore();
const cart = useCartStore();

const copilotPrice = computed(() => {
  const subscription =
    microsoft365Catalog.getSubscriptionById(28)?.priceRecurring
      ?.unitPriceWithDiscount;

  return subscription;
});
</script>

<style></style>
